import React from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { generateDataTestId } from '../../../../utils';
import { PropertyField } from '../../../../system/field';

interface AddressTaxIdSelectorProps {
  searchMode: 'address' | 'taxId';
  onSearchModeChange: (mode: 'address' | 'taxId') => void;
  isMobile?: boolean;
}

/**
 * AddressTaxIdSelector component - handles the search mode selection for Realist flow
 * Provides radio buttons to switch between Address and Tax ID search modes
 */
const AddressTaxIdSelector: React.FC<AddressTaxIdSelectorProps> = ({
  searchMode,
  onSearchModeChange,
  isMobile = false,
}) => {
  if (isMobile) {
    // On mobile, return just the Tax ID radio option to be included in the existing RadioGroup
    return (
      <FormControlLabel
        value="taxId"
        control={
          <Radio
            data-testid={generateDataTestId(
              PropertyField.LOCATION_TYPE,
              undefined,
              'radioField-taxId',
            )}
          />
        }
        label="Tax ID"
      />
    );
  }

  // Desktop: Standalone RadioGroup for Address/Tax ID selection
  return (
    <RadioGroup
      row
      value={searchMode}
      onChange={(e) =>
        onSearchModeChange(e.target.value as 'address' | 'taxId')
      }
      sx={{ mb: 1 }}
    >
      <FormControlLabel
        value="address"
        control={
          <Radio
            data-testid={generateDataTestId(
              PropertyField.LOCATION_TYPE,
              undefined,
              'radioField-address',
            )}
          />
        }
        label="Address"
        sx={{ mr: 3 }}
      />
      <FormControlLabel
        value="taxId"
        control={
          <Radio
            data-testid={generateDataTestId(
              PropertyField.LOCATION_TYPE,
              undefined,
              'radioField-taxId',
            )}
          />
        }
        label="Tax ID"
      />
    </RadioGroup>
  );
};

export default AddressTaxIdSelector;
